// extracted by mini-css-extract-plugin
module.exports = {"compareGoToBasket":"go-to-basket_compareGoToBasket__C2AMz"};